<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [title]="editingBlock ? 'Edit Blocked Dates' : 'Block Dates'"
      [class]="extraClass"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container
*ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <form [formGroup]="form" action="#">
        <tidy-row>
          <tidy-select
            [label]="'Property'"
            [items]="addressFilter"
            [multiple]="false"
            [form]="form.get('property')"
            [icon]="'assets/svg/home.svg'"
            [errorMessage]="'Please select a property.'"
            [submitted]="submitted"
            [disableElement]="!!editingBlock"
            formControlName="property" />
        </tidy-row>
        <tidy-row>
          <tidy-datepicker
            label="First Blocked Day"
            [icon]="'assets/svg/calendar.svg'"
            formControlName="startDate"
            [form]="form.controls.startDate"
            errorMessage="Please enter a valid date."
            (optionChange)="onDateChange()"
            [submitted]="submitted" />
        </tidy-row>
        <tidy-row>
          <tidy-datepicker
            label="Last Blocked Day"
            [icon]="'assets/svg/calendar.svg'"
            formControlName="endDate"
            [form]="form.controls.endDate"
            [minDate]="form.controls.startDate.value"
            [minSameDate]="true"
            errorMessage="Please enter a valid date."
            (optionChange)="onDateChange()"
            [submitted]="submitted" />
        </tidy-row>
        <tidy-row>
          <tidy-textarea
            [label]="'Block Reason (optional)'"
            [helperText]="'e.g. Owner staying, repairs'"
            [icon]="'assets/svg/create-outline.svg'"
            formControlName="reason"
            [form]="form.controls.reason"
            [errorMessage]="'Please keep the reason to 500 characters or fewer.'"
            [submitted]="submitted" />
        </tidy-row>

        <tidy-row>
          <tidy-text [helper]="'Guests won\'t be able to book these dates. You can unblock them anytime.'" />
        </tidy-row>

        @if (previewRangeLabel) {
          <tidy-row>
            <div class="owner-block-preview">
              <span class="owner-block-preview-lock"></span>
              <span class="owner-block-preview-range">{{ previewRangeLabel }}</span>
              <span class="owner-block-preview-nights">{{ previewNightsLabel | translate }}</span>
            </div>
          </tidy-row>
        }

        <tidy-row style="padding-top: 1rem;">
          <tidy-button
            [text]="editingBlock ? 'Save Changes' : 'Block Dates'"
            class="primary"
            [action]="boundBlockDates" />
        </tidy-row>
      </form>
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
